'use client';

import { Link as FreddyLink, Modal, ModalBody, ModalHeader } from '@coolblue-development/freddy';
import readExplanationLeasingTrigger from '@coolblue-development/ga4-events/triggers/OrderBlock/readExplanationLeasingTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { useFreddyTranslations } from '@coolblue-development/next-design-system-utils/client';
import { useTranslation } from '@i18n/useTranslation';
import Link from 'next/link';
import { useState } from 'react';

import ModalContent from './ModalContent';

type SubjectType = 'item' | 'label';

const ModalButton = () => {
  const { trackEvent } = useAnalytics();
  const { t } = useTranslation('webshop.business.leasing.modal');
  const modalTranslations = useFreddyTranslations('modal');

  const [isOpen, setIsOpen] = useState(false);

  const handleModalClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();

    const params = {
      subject_type: 'item' as SubjectType,
      subject_id: 'leasing_details'
    };

    trackEvent(readExplanationLeasingTrigger(params));
    setIsOpen(true);
  };

  return (
    <>
      <Link href='#link' passHref legacyBehavior>
        <FreddyLink component='button' onClick={handleModalClick}>
          {t('readMore')}
        </FreddyLink>
      </Link>
      <Modal
        translations={modalTranslations}
        open={isOpen}
        onClose={() => setIsOpen(false)}
        size={{
          xs: 'small',
          md: 'xlarge'
        }}
        header={
          <ModalHeader
            title={t('titles.main')}
            closeButtonProps={{
              'aria-label': t('ariaLabelClose'),
              onClick: () => setIsOpen(false)
            }}
          />
        }
        body={
          <ModalBody>
            <ModalContent />
          </ModalBody>
        }
      />
    </>
  );
};

export default ModalButton;
